import * as React from 'react';
export const IcReplay = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11 15c.196-.002.387-.06.55-.17l3-2a1 1 0 000-1.66l-3-2a1 1 0 00-1-.05A1 1 0 0010 10v4a1 1 0 00.53.88c.145.078.306.12.47.12zm1-13A10 10 0 002 12a8.32 8.32 0 00.07 1.12 1.007 1.007 0 102-.24A8.49 8.49 0 014 12a8 8 0 112.73 6h.77a1 1 0 000-2h-3a1 1 0 00-1 1v3a1 1 0 002 0v-.43A10 10 0 1012 2z'
      fill='currentColor'
    />
  </svg>
);
